import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import CustomTextField from "../CustomTextField";
import { DialogTitle, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {  useSelector } from "react-redux";
import { UserAuth } from "../../context/AuthContext";
import { useEffect } from "react";

const ModalRegistroSubperiodo = ({ open, handleClose, subperiodo, onSubmit }) => {
  const theme = useTheme();
  const { empleado } = UserAuth();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const loadSubperiodoAprobarRechazar = useSelector((store) => store.vacaciones.loadSubperiodoAprobarRechazar);

  const defaultValues = {
    empleado: empleado.empleadoid,
    unidadOrganizativaID: null,
    aprobadorId: null,
    id: null,
    cantidadLicencias: null,
    tamanioNomina: null,
  };

  const validacionSchema = yup.object().shape({});

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { reset } = methods;

  useEffect(() => {
    reset(subperiodo);
  }, [subperiodo, reset]);

  const handleAcceptRechazar = (estado) => {
    onSubmit(subperiodo.id, estado)
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="unidadOrganizativa"
                label="Unidad Organizativa"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="subperiodo"
                label="Subperiodo Vacacional asociado"
                readOnly={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="tamanioNomina"
                label="Tamanio Nomina"
                readOnly={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="cumplirObjetivo"
                label="Porcentaje a cumplir objetivo"
                readOnly={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="licenciasSubperiodo"
                label="Porcentaje licencias en el subperiodo para la UO"
                readOnly={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="cantidadLicencias"
                label="Cantidad Licencias"
                readOnly={true}
              />
            </Grid>
            <Box sx={{ height: "100%" }}>
              <Typography>Aprobación</Typography>
            </Box>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="aprobador"
                label="Aprobador"
                readOnly={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                  Aprobar o rechazar
                </Typography>
                <Box 
                  sx={{
                    minWidth: "100%", 
                    display: "flex", 
                    flexDirection:"column", 
                    gap:2, 
                    mb:2 
                  }}>
                  <Button
                    sx={{ minWidth: "100%" }}
                    variant="outlined"
                    onClick={() => handleAcceptRechazar('100000000')}
                    disabled={loadSubperiodoAprobarRechazar === "LOADING"}
                    color="success"
                  >
                    Aceptar
                  </Button>
                  <Button
                    sx={{ minWidth: "100%" }}
                    variant="outlined"
                    onClick={() => handleAcceptRechazar('100000001')}
                    disabled={loadSubperiodoAprobarRechazar === "LOADING"}
                    color="error"
                  >
                    Rechazar
                  </Button>
                </Box>
              </Box>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
export default ModalRegistroSubperiodo;
